import { CatalogServiceDto, ServiceType } from '@wix/bookings-uou-types';

export const showExplorePlansForService = (service: CatalogServiceDto) =>
  service.pricingPlanInfo.pricingPlans.length > 0 &&
  service.type !== ServiceType.COURSE &&
  !service.schedulePolicy.displayOnlyNoBookFlow &&
  !service.schedulePolicy.isPendingApprovalFlow;
